require('./bootstrap.js');
window.moment = require('moment');
window.moment = require('moment-timezone');
import Vue from 'vue';


import HomeSearch from './components/HomeSearch.vue';
import ReservationForm from './components/ReservationForm.vue';
import FilterForm from './components/FilterForm.vue';
import ChatWidget from './components/ChatWidget.vue';

const app = new Vue({
    el: '#app',
    components:{
        ReservationForm,
        FilterForm,
        HomeSearch,
        ChatWidget,
    }
});
